import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarEventsLoadingState } from './types/CalendarEventsLoadingState';
import { EventsCacheLockId } from 'owa-events-cache';
import { FullItemLoadState } from './store/schema/FullItemsMruMap';
import { getCalendarEventWithId as getCalendarEventEntityWithId } from './selectors/calendarFolderEventsSelectors';
import './orchestrators/eventsCacheOrchestrators';
import './orchestrators/instantCalendarEventCreateOrchestrator';
import './mutators/eventsCacheMutators';
import './mutators/fullItemsMruMapMutators';
import './orchestrators/instantCalendarEventDeleteOrchestrator';
import './orchestrators/updateCalendarEventFailedOrchestrator';
import './orchestrators/updateFullCalendarEventFromServerOrchestrator';
import './orchestrators/instantCalendarEventUpdateOrchestrator';
import {
    LockedCalendarEventsStore,
    LockedCalendarEventsReader,
} from './types/LockedCalendarEventsStore';

// Actions
export * from './actions/publicActions';
export * from './actions/publicEventsCacheActions';

// Util functions
export {
    subscribeNotifications,
    unsubscribeNotifications,
    resumeNotificationsProcessing,
    suspendNotificationsProcessing,
} from './utils/CalendarItemNotifications';
export { getCalendarCharmIdByFolderId } from './utils/calendarCharmResolver';
export { getCharm } from './utils/getCharm';
export { default as getItemIdToUpdate } from './utils/getItemIdToUpdate';
export { getFullItemLoadState } from './selectors/fullItemInfoSelectors';
export { reloadAllCalendarEventsCache } from './utils/eventsCache/reloadAllCalendarEventsCache';
export { default as getEventKey } from './utils/getEventKey';

// Services functions
export { getUserAvailabilityService } from './services/getUserAvailabilityService';

// Locked calendar folder events functions
export {
    createLockedCalendarEventsStore,
} from './utils/lockedCalendarEvents/createLockedCalendarEventsStore';
export {
    getLockedCalendarEventsStore,
} from './utils/lockedCalendarEvents/getLockedCalendarEventsStore';
export {
    getLockedCalendarEventsReader,
} from './utils/lockedCalendarEvents/getLockedCalendarEventsReader';

export { getAllCalendarEvents } from './selectors/eventsCacheSelectors';

// Types
export {
    EventsCacheLockId,
    LockedCalendarEventsStore,
    LockedCalendarEventsReader,
    FullItemLoadState,
    CalendarEventsLoadingState,
};

/**
 * Return event from cache given ID.  Does not lock event.
 * @param eventId ID of the event to fetch
 */
export const getCalendarEventWithId: (
    eventId: string,
    folderId?: string
) => CalendarEvent = getCalendarEventEntityWithId;
